import { useFinanceiroStatusTag } from "./use-financeiro-status-tag";
import { FinanceiroStatusTagView } from "./view-financeiro-status-tag";
import type { FinanceiroStatusTagProps } from "./types-financeiro-status-tag";

export function FinanceiroStatusTag(props: FinanceiroStatusTagProps) {
  const vm = useFinanceiroStatusTag(props);
  return <FinanceiroStatusTagView {...vm} />;
}

export type * from "./types-financeiro-status-tag";
